/**
 * Agents Service - Unified API Implementation
 * Clean implementation using the new unified REST API structure
 */

import { repositories } from '../api/createRepositories';

const agentsRepository = repositories.agents;

export const agentsService = {
  createAgent: async (agentConfig) => {
    return await agentsRepository.createAgent(agentConfig);
  },

  getAgents: async (options = {}) => {
    const agents = await agentsRepository.getAgents(options);
    // API returns agents array directly
    return {
      agents: agents,
      total: agents.length,
      hasMore: false,
    };
  },

  getAgentById: async (agentId) => {
    return await agentsRepository.getAgentById(agentId);
  },

  updateAgent: async (agentId, updateData) => {
    return await agentsRepository.updateAgent(agentId, updateData);
  },

  deleteAgent: async (agentId) => {
    await agentsRepository.deleteAgent(agentId);
    return { success: true };
  },

  duplicateAgent: async (sourceAgentId, newSettings) => {
    return await agentsRepository.duplicateAgent(sourceAgentId, newSettings);
  }

};

export default agentsService;